import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllUnmapForm(payload: any) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETUNMAPFORM +  
          `?page=${payload.pageNumber}&limit=${payload.pageSize}&search=${payload.search || ""}`,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  export async function updateUnmapForm(payload: any) {
    try {
      const callParams = await getCallParams("PUT", payload);
      const response = await makeCall(urls.UPDATEUNMAPFORM, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }